export default __webpack_public_path__ + "static/media/welcome.b9bfa4eb.png";